import { Component, Element, Prop, h, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'spw-link',
  styleUrl: 'spw-link.scss',
  shadow: true,
})
export class SpwLink {
  @Element() el: HTMLSpwLinkElement;

  /** Spécifie le lien href */
  @Prop() href: string;
  /** Attribut target (détermine où ouvrir le lien) */
  @Prop() target?: string = '_self';
  /** Remplit l'attribut rel */
  @Prop() rel?: string;
  /** Si rempli, permet d'utiliser une référence d'icône font-awesome */
  @Prop() icon?: string;
  /** Position de l'icône à l'intérieur du lien (gauche ou droite) */
  @Prop() iconPosition?: 'left' | 'right' = 'right';
  /** Si désactivé, le lien n'est pas cliquable */
  @Prop() disabled?: boolean = false;
  /** Remplit l'attribut aria-label, utilisé à des fins d'accessibilité */
  @Prop() accAriaLabel?: string;
  /** Permet de choisir la surface d'arrière-plan du lien */
  @Prop() surface?: 'light' | 'dark' = 'light';

  /** Événement déclenché lors du clic sur le lien */
  @Event() spwClick: EventEmitter<MouseEvent>;

  private onClick = (ev: MouseEvent) => {
    if (this.disabled) {
      ev.preventDefault();
      return;
    }
    this.spwClick.emit(ev);
  };

  private get elementClass(): { [className: string]: boolean } {
    return {
      'spw-link': true,
      'spw-link--has-icon-right': this.icon && this.iconPosition === 'right',
      'spw-link--has-icon-left': this.icon && this.iconPosition === 'left',
      [`spw-link--surface-${this.surface}`]: true,
      'spw-link--has-icon': !!this.icon,
    };
  }

  render() {
    const { href, rel, target, icon, iconPosition, accAriaLabel, disabled } = this;
    const ariaAttributes = {
      'aria-label': accAriaLabel,
      'aria-disabled': disabled ? 'true' : null,
    };

    const iconClass = `spw-icon--${iconPosition}`;
    const iconElement = icon ? <spw-icon class={iconClass} icon={icon}></spw-icon> : null;

    return (
      <a href={disabled ? undefined : href} rel={rel} target={target} class={this.elementClass} onClick={this.onClick} {...ariaAttributes}>
        {iconPosition === 'left' && iconElement}
        <div class="spw-link__inner">
          <slot></slot>
        </div>
        {iconPosition === 'right' && iconElement}
      </a>
    );
  }
}
